import Vue from 'vue'
import VueRouter from 'vue-router'
import MapController from '../views/MapController.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'mapController',
    component: MapController
  },
]

const router = new VueRouter({
  routes
})

export default router
